import { ClinicalEncounterActions } from "./ClinicalEncounterActions";
import dayjs from "dayjs";
import { useOrganizationContext } from "../../../../../contexts/OrganizationContext";
import { currentFeatures } from "@/configs/Settings";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";
import {
  resolveAttendanceSpecialty,
  resolveAttendanceTypeLabel,
} from "@/utils/resolveAttendanceSpecialty";

interface IProps {
  title: string;
  data: any;
  openVisualizer: any;
  verifyVisualizer: any;
}

export function ClinicalEncounter({
  title,
  data,
  openVisualizer,
  verifyVisualizer,
}: IProps) {
  const { organizationList } = useOrganizationContext();

  const columns = [
    {
      column: "Organização",
      rowName: "organization",
      width: "22%",
      lineClamp: 2,
    },
    {
      column: "Especialidade",
      rowName: "serviceType",
      width: "16%",
    },
    {
      column: "Tipo de atendimento",
      rowName: "attendanceType",
      width: "16%",
    },
    {
      column: "Profissional",
      rowName: "practitioner",
      width: "22%",
      lineClamp: 2,
    },
    { column: "Data", rowName: "date", width: "12%" },
  ];

  const rowData = data?.map((el: any) => {
    const encounter = el?.encounter;
    const questionnaire = el?.questionnaire?.[0]?.resource;

    return {
      appointmentId:
        el?.encounter?.appointment?.[0]?.reference?.split("/")?.[1],
      subject: currentFeatures.defaultApp
        ? encounter?.subject?.reference?.split("-")?.[1]
        : encounter?.subject?.reference?.split("/")?.[1],
      encounterId: el?.encounter?.id,
      participant: el?.encounter?.participant,
      organizationId: encounter?.serviceProvider.reference.split("-")[1],
      status: el?.encounter?.status,
      organization:
        organizationList?.find((el: any) =>
          el.resource.id.includes(
            encounter?.serviceProvider.reference.split("/")[1]
          )
        )?.resource?.name ||
        encounter?.serviceProvider.reference.split("-")[1],
      serviceType: resolveAttendanceSpecialty({ encounter }),
      attendanceType: resolveAttendanceTypeLabel(encounter),
      date: dayjs(encounter?.actualPeriod?.start).format("DD/MM/YYYY"),
      questionnarie: questionnaire?.item,
      observations: el?.obs,
      practitioner:
        encounter?.participant
          ?.find((el: any) => el?.actor?.reference?.includes("Practitioner"))
          ?.actor?.display.toUpperCase() ||
        encounter?.participant?.find((el: any) =>
          el?.actor?.reference?.includes("Practitioner")
        )?.actor?.value ||
        encounter?.participant?.find((el: any) =>
          el?.actor?.type?.includes("Practitioner")
        )?.actor?.identifier?.value,
    };
  });

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={(rowData: any) => (
        <ClinicalEncounterActions
          verifyVisualizer={verifyVisualizer}
          openVisualizer={openVisualizer}
          row={rowData}
        />
      )}
    />
  );
}
